import React from 'react';
import './Loader.scss';

type props = {}

export const Loader = (props: any) =>  
<div className="component-loader">  
    <div className="spinner-border" role="status">
        {/* <span className="sr-only">Loading...</span> */}
    </div>
</div>

    